import api from '../../../services/api';

/**
 * WP4 — who receives the e-mail after a customer order is confirmed
 * (backend: orderConfirmationNoticeService.js, ADMIN only).
 */
export type ConfirmationNoticeRole = 'ADMIN' | 'OPERATIONS';

export const CONFIRMATION_NOTICE_ROLES: ConfirmationNoticeRole[] = ['ADMIN', 'OPERATIONS'];

export interface ConfirmationNoticeRecipientsDto {
  includeRoles: ConfirmationNoticeRole[];
  includeAccountManager: boolean;
  userIds: string[];
}

export interface NotificationUserOptionDto {
  id: string;
  name: string;
  email: string;
  role: string;
}

const PATH = '/notifications/order-confirmed-stock/recipients';

function normalize(data: any): ConfirmationNoticeRecipientsDto {
  return {
    includeRoles: Array.isArray(data?.includeRoles)
      ? data.includeRoles.filter((role: unknown): role is ConfirmationNoticeRole => (
        CONFIRMATION_NOTICE_ROLES.includes(role as ConfirmationNoticeRole)
      ))
      : [],
    includeAccountManager: data?.includeAccountManager === true,
    userIds: Array.isArray(data?.userIds) ? data.userIds.filter((id: unknown) => typeof id === 'string') : [],
  };
}

export async function fetchConfirmationNoticeRecipients(): Promise<ConfirmationNoticeRecipientsDto> {
  const response = await api.get(PATH);
  return normalize(response.data);
}

export async function saveConfirmationNoticeRecipients(
  payload: ConfirmationNoticeRecipientsDto
): Promise<ConfirmationNoticeRecipientsDto> {
  const response = await api.put(PATH, {
    includeRoles: payload.includeRoles,
    includeAccountManager: payload.includeAccountManager,
    userIds: payload.userIds,
  });
  return normalize(response.data);
}

/** Active users an ADMIN can pick (same list as the recipient-pool settings). */
export async function fetchNotificationUserOptions(): Promise<NotificationUserOptionDto[]> {
  const response = await api.get('/notifications/recipients-config');
  return (Array.isArray(response.data) ? response.data : []).map((user: any) => ({
    id: String(user.id),
    name: String(user.name || user.email || ''),
    email: String(user.email || ''),
    role: String(user.role || ''),
  }));
}
